import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { MdKeyboardArrowDown } from "react-icons/md";
import {
  FCard,
  FGrid,
  FTooltip,
  FGridItem,
  FContainer,
} from "ferrum-design-system";
import { useWalletConnector, useKeplrWalletConnector } from "foundry";
import { useAlgoSignerWalletConnector } from "foundry";
// import { networkImages } from "../../../../utils/networkImages";
import { RiErrorWarningLine } from "react-icons/ri";
import { SwapPageIntroCard } from "./SwapPageIntroCard";
import { MsDestinationDialog } from "../../components/dialogs/MsDestinationDialog";
import { MsSlippageToleranceDialog } from "../../components/dialogs/MsSlippageToleranceDialog";
import { MsSelectFeeTokenDlg } from "../../components/dialogs/MsSelectFeeTokenDlg";
import { MsTokenListDialog } from "../../components/dialogs/MsTokenListDialog";
import { SwapPageTokenNetworkSelector } from "./SwapPageTokenNetworkSelector";
import { RootState } from "../../../../redux/rootReducer";
import { SwapPageActionButtons } from "./SwapPageActionButtons";
import { addClassToBodyTag } from "../../../../utils/helperFunctions";
import { SwapProgressBar } from "./SwapProgressBar";
import { COMING_SOON, TOKEN_TAG } from "../../../../utils/const.utils";
import { CategorizationProgressBar } from "./CategorizationProgressBar";
import { AbiItem } from "web3-utils";
import FerrumJson from "./../../../../../src/utils/abi/FerrumToken.json";
import * as swapActions from "../../../../redux/slices/swap";
import * as contractAllocationActions from "../../../../redux/slices/contract";
import * as networkActions from "../../../../redux/slices/network";
import swapSwitchIcon from "../../../../assets/ms-new-images/icons/directional-ms-swap-icon.png";
import Loader from "../../../../assets/img/loader-m.png";
import toggleIcon from "../../../../assets/ms-new-images/icons/ms-toggle-icon.png";
import addItemIcon from "../../../../assets/ms-new-images/icons/ms-add-item-icon.svg";
import fiberEngineIcon from "../../../../assets/ms-new-images/icons/ms-fiber-engine-icon.png";
import MultiSwapBeta from "../../../../assets/img/multiswap-banner.svg";
import MultiSwapBetaMobile from "../../../../assets/img/multiswap-banner-mobile.svg";
import SwapMobilePage from "./SwapMobilePage";
import "react-step-progress-bar/styles.css";
import { useHistory } from "react-router";
import ReactTooltip from "react-tooltip";
// import toast from "react-hot-toast";
import Web3 from "web3";
import Big from "big.js";
import useTokenBalance from "../../../../hooks/useTokenBalance";

const SwapPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const authToken = localStorage.getItem(TOKEN_TAG);
  const inputRef = useRef<HTMLInputElement>(null);
  const maxRef = useRef<HTMLInputElement>(null);
  const sendToRef = useRef<HTMLInputElement>(null);
  const queryParams = new URLSearchParams(window.location.search);
  const [quoteLoading, setQuoteLoading] = useState<boolean>(false);
  const slippage = queryParams.get("slippage") || "2";
  const demoMode = Boolean(queryParams.get("demo"));
  const [amount, setAmount] = useState<string>(queryParams.get("amount") || "");
  const [showAmountWarning, setShowAmountWarning] = useState(false);
  // const [maxBalance, setMaxBalance] = useState<string>("0");
  const [showTokenSelectorDialog, setShowTokenSelectorDialog] =
    useState<boolean>(false);
  const [tokenSelectorDialogFor, setTokenSelectorDialogFor] =
    useState<string>("FROM_TOKEN");
  const [showFeeTokenSelectorDialog, setShowFeeTokenSelectorDialog] =
    useState<boolean>(false);
  const [showSwapToggleDialog, setShowSwapToggleDialog] =
    useState<boolean>(false);
  const [showDestinationAddressDialog, setShowDestinationAddressDialog] =
    useState<boolean>(false);
  const [sendToToggle, setSendToToggle] = useState<boolean>(
    queryParams.get("sendTo") ? true : false
  );
  const [networkParamsShift, setNetworkParamsShift] = useState(false);
  const [destinationAddress, setDestinationAddress] = useState<string>(
    queryParams.get("sendTo") || ""
  );
  const [isDestinationAddressValid, setIsDestinationAddressValid] =
    useState(false);
  const [progressBar, setProgressBar] = useState(0);
  const [destinationMobileProgressBar, setDestinationMobileProgressBar] =
    useState(false);
  const [show, setShow] = useState(false);
  const [categorizedAndQuoteApiHit, setCategorizedAndQuoteApiHit] =
    useState("");
  // const [destinationAmountLoaderIcon, setDestinationAmountLoaderIcon] =
  //   useState(false);
  const [networkProgressBarDisable, setNetworkProgressBarDisable] =
    useState(false);
  const { isAlgoConnected } = useAlgoSignerWalletConnector();
  const { isConnected, web3Sdk, walletAddress } = useWalletConnector();
  const {
    isKeplrConnected,
    connectedKeplrWalletAddress,
    keplrWalletBalance,
    CosmWasmClient,
  } = useKeplrWalletConnector();

  const {
    isApproving,
    fromInfo,
    toInfo,
    networksPayload,
    selectedNetwork,
    allTokens,
    isTokenQuoteLoading,
    isSwapping,
    swapAndWithdrawTxStatus,
    // tokenV2: authToken,
    toNetworkTokenList,
    fromNetworkTokenList,
    estimatedSwapTime,
    tokenQuoteError,
    swapProgressBarStatus,
    isSwappingScreenBlocked,
    showSwapAndWithdrawDialog,
    destinationTokenCategorizedInfo: { destinationAmount },
  } = useSelector((state: RootState) => ({
    ...state.contract,
    ...state.swap,
    ...state.networks,
    ...state.walletAuthenticator,
  }));

  const { tokenBalance: maxBalance } = useTokenBalance(
    walletAddress,
    fromInfo?.token?.address,
    fromInfo?.token?.isNative,
    fromInfo?.network?.rpcUrl
  );

  useEffect(() => {
    const inputCurrency = queryParams.get("inputCurrency");
    const outputCurrency = queryParams.get("outputCurrency");
    const inputChainId = queryParams.get("inputChainId");
    const outputChainId = queryParams.get("outputChainId");
    const inputAmount = queryParams.get("amount");
    const destinationAddress = queryParams.get("sendTo");
    const focusType = localStorage.getItem("persist:focusType");
    if (
      authToken &&
      (inputChainId || selectedNetwork) &&
      inputCurrency &&
      !fromInfo?.token &&
      fromInfo?.token?.address !== inputCurrency
    ) {
      currencySelectionByURLQuery(
        inputChainId ?? selectedNetwork?.chainId,
        inputCurrency,
        fromInfo,
        "FROM",
        authToken as string
      );
    } else if (
      inputChainId &&
      !fromInfo?.network &&
      fromInfo?.network !== inputChainId
    ) {
      networkSelectionByURLQuery(inputChainId, "FROM");
    }
    if (
      authToken &&
      outputChainId &&
      outputCurrency &&
      (!toInfo?.token || !toInfo?.network) &&
      toInfo?.token?.address !== outputCurrency
    ) {
      currencySelectionByURLQuery(
        outputChainId,
        outputCurrency,
        toInfo,
        "TO",
        authToken as string
      );
    } else if (
      outputChainId &&
      !toInfo?.network &&
      toInfo?.network !== outputChainId
    ) {
      networkSelectionByURLQuery(outputChainId, "TO");
    }
    if (inputAmount) {
      const item = localStorage.getItem("persist:max");
      setAmount(inputAmount);
      setCategorizedAndQuoteApiHit(inputAmount);
      if (item !== "true" && focusType === "amount") {
        inputRef.current?.focus();
      } else if (item === "true") {
        localStorage.setItem("persist:max", "false");
        inputRef.current?.setSelectionRange(0, 0);
        inputRef.current?.focus();
      }
    }
    if (destinationAddress) {
      if (focusType === "sendTo") {
        sendToRef.current?.focus();
      }
      // setDestinationAddress(destinationAddress);
      setSendToToggle(true);
      setIsDestinationAddressValid(
        toInfo?.network?.isNonEVM
          ? destinationAddress.includes("cudos") &&
              destinationAddress.length === 44
          : Web3.utils.isAddress(destinationAddress)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (walletAddress || connectedKeplrWalletAddress) {
      // Resetting the data on changing wallet account
      dispatch(swapActions.resetToAndFromState());
      dispatch(contractAllocationActions.resetContractAllocationState());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletAddress, connectedKeplrWalletAddress]);

  useEffect(() => {
    if (swapProgressBarStatus === 100) {
      setAmount("");
      setDestinationAddress("");
      queryParams.set("amount", "");
      dispatch(swapActions.resetDestinationAmount());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swapProgressBarStatus]);

  useEffect(() => {
    if (fromInfo?.network && toInfo?.network) {
      dispatch(
        swapActions.getEstimatedSwapTime(
          fromInfo?.network?._id,
          toInfo?.network?._id
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromInfo?.network, toInfo?.network, amount]);

  useEffect(() => {
    if (destinationAddress) {
      setIsDestinationAddressValid(
        toInfo?.network?.isNonEVM
          ? destinationAddress.includes("cudos") &&
              destinationAddress.length === 44
          : Web3.utils.isAddress(destinationAddress)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toInfo?.network]);

  useEffect(() => {
    if (
      fromInfo?.token?.symbol !== "cFRM" &&
      toInfo?.token?.symbol === "cFRM"
    ) {
      dispatch(swapActions.setToInfo({ ...toInfo, token: undefined }));
      dispatch(swapActions.setToTokens([]));
    }
    setProgressBar(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromInfo?.token, toInfo?.token]);

  useEffect(() => {
    if (
      fromInfo?.token?.decimals &&
      amount?.toString().split(".")[1]?.length > fromInfo?.token?.decimals
    ) {
      dispatch(swapActions.resetDestinationAmount());
      // toast.error(
      //   `Amount should be less than or equal to ${fromInfo?.token?.decimals} decimal places`
      // );
    }
    const delayDebounceFn = setTimeout(() => {
      if (
        isConnected &&
        amount &&
        Number(amount) > 0 &&
        categorizedAndQuoteApiHit &&
        fromInfo?.network &&
        fromInfo?.token &&
        toInfo?.network &&
        toInfo?.token
      ) {
        // setShow(true);
        if (
          fromInfo?.token?.decimals &&
          amount?.toString().split(".")[1]?.length > fromInfo?.token?.decimals
        ) {
          dispatch(swapActions.resetDestinationAmount());
        } else if (
          isConnected &&
          walletAddress &&
          !isSwapping &&
          swapAndWithdrawTxStatus === ""
        ) {
          // setDestinationAmountLoaderIcon(true);
          dispatch(
            swapActions.getTokenCategorizedInformation(
              walletAddress,
              fromInfo?.token?.address,
              fromInfo?.network?.chainId,
              amount,
              Web3.utils.isAddress(destinationAddress)
                ? destinationAddress
                : "",
              toInfo?.token?.address,
              toInfo?.network?.chainId,
              "",
              false
            )
          );
        }
      }
    }, 1500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    showSwapAndWithdrawDialog,
    categorizedAndQuoteApiHit,
    amount,
    fromInfo?.network,
    fromInfo?.token,
    toInfo?.network,
    toInfo?.token,
  ]);

  useEffect(() => {
    if (destinationAmount) {
      setShow(false);
      setProgressBar(100);
      // setDestinationAmountLoaderIcon(false);
      setDestinationMobileProgressBar(true);
      setQuoteLoading(false);
    }
    if (tokenQuoteError) {
      setQuoteLoading(false);
      // setDestinationAmountLoaderIcon(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [destinationAmount, tokenQuoteError]);

  const onSourceAmountChange = async (e: any) => {
    try {
      if (
        e.target.value.toString().split(".")[1]?.length >
        fromInfo?.token?.decimals
      ) {
        return;
      }
      // setAmount(e.target.value);
      dispatch(swapActions.resetDestinationAmount());
      // setDestinationAmountLoaderIcon(false);
      queryParams.set("amount", e.target.value);
      localStorage.setItem("persist:focusType", "amount");
      if (e.target.value > 0.0) {
        setQuoteLoading(true);
        setCategorizedAndQuoteApiHit(e.target.value);
        setNetworkProgressBarDisable(false);
        setShowAmountWarning(false);
        setProgressBar(35);
        // if (new Big(e.target.value).gt(new Big(maxBalance))) {
        //   setShowAmountWarning(true);
        //   setQuoteLoading(false);
        //   toast.error("You do not have that much balance.");
        // }
      } else {
        setShowAmountWarning(true);
        setProgressBar(0);
      }
      history.push({
        pathname: "/swap",
        search: queryParams.toString(),
      });
    } catch (e) {
      console.log(e);
    }
  };

  const currencySelectionByURLQuery = (
    chainId: string,
    currency: string,
    selectorInfo: any,
    direction: string,
    authToken: string
  ) => {
    let network = selectorInfo?.network;
    if (!network) {
      network = networkSelectionByURLQuery(chainId, direction);
    }
    dispatch(
      swapActions.updateFromInfoToken(
        allTokens,
        network,
        currency,
        direction,
        authToken
      )
    );
  };
  //dispatch(swapActions.getTokensInfo(token, direction, chainId));
  const networkSelectionByURLQuery = (chainId: string, direction: string) => {
    let network;
    if (selectedNetwork && selectedNetwork.chainId === chainId) {
      network = selectedNetwork;
    } else {
      networksPayload.forEach((item: any) => {
        if (item?.chainId === chainId) {
          network = item;
        }
      });
    }
    if (!network) {
      networkActions
        .getNetworkByChainId(chainId)
        .then((response) => (network = response));
    }
    if (network && direction === "FROM") {
      dispatch(swapActions.setFromInfo({ ...fromInfo, network }));
    } else if (direction === "TO") {
      dispatch(swapActions.setToInfo({ ...fromInfo, network }));
    }
    return network;
  };

  const sourceMaxButton = () => {
    localStorage.setItem("persist:max", "true");
    setQuoteLoading(true);
    setCategorizedAndQuoteApiHit(maxBalance.toString());
    setAmount(maxBalance);
    queryParams.set("amount", maxBalance.toString());
    history.push({
      pathname: "/swap",
      search: queryParams.toString(),
    });
  };

  const switchFromAndToInfo = () => {
    if (fromInfo && toInfo) {
      if (toInfo?.network?.chainId && toInfo?.token?.address) {
        queryParams.set("inputCurrency", toInfo?.token?.address);
        queryParams.set("inputChainId", toInfo?.network?.chainId);
      }
      if (fromInfo?.network?.chainId && fromInfo?.token?.address) {
        queryParams.set("outputCurrency", fromInfo?.token?.address);
        queryParams.set("outputChainId", fromInfo?.network?.chainId);
      }
      if (destinationAmount) {
        queryParams.set("amount", destinationAmount);
        dispatch(swapActions.resetDestinationAmount());
      }

      history.push({
        pathname: "/swap",
        search: queryParams.toString(),
      });
      dispatch(swapActions.exchangeSwapInfo(fromInfo, toInfo));
    }
  };

  const SwapActionProps = {
    amount,
    toInfo,
    fromInfo,
    maxBalance,
    quoteLoading,
    showAmountWarning,
    destinationAddress,
    toNetworkTokenList,
    fromNetworkTokenList,
    setShowAmountWarning,
    setTokenSelectorDialogFor,
    setShowTokenSelectorDialog,
    setNetworkProgressBarDisable,
    isAnyWalletConnected: isConnected || isKeplrConnected || isAlgoConnected,
  };

  const SwapMobilePageProps = {
    show,
    toInfo,
    amount,
    setAmount,
    fromInfo,
    maxBalance,
    progressBar,
    isApproving,
    sendToToggle,
    showAmountWarning,
    networkParamsShift,
    destinationAddress,
    isDestinationAddressValid,
    destinationMobileProgressBar,
    setShow,
    sourceMaxButton,
    setSendToToggle,
    onSourceAmountChange,
    setDestinationAddress,
    setTokenSelectorDialogFor,
    setNetworkParamsShift,
    setShowTokenSelectorDialog,
    setIsDestinationAddressValid,
    setCategorizedAndQuoteApiHit,
    swapActionButton: () => <SwapPageActionButtons {...SwapActionProps} />,
    switchFromAndToInfo,
    setShowSwapToggleDialog,
    showSwapToggleDialog,
  };

  return (
    <FContainer
      width={920}
      className="bridge-futuristic-wrapper position-relative"
    >
      <img
        src={MultiSwapBeta}
        alt="extra info card"
        className="metamask-beta-img"
      />
      <img
        src={MultiSwapBetaMobile}
        alt="extra info mobile card"
        className="metamask-beta-mobile"
      />
      {!demoMode && !isConnected ? (
        <SwapPageIntroCard />
      ) : (
        <>
          {(demoMode ||
            (isConnected && walletAddress) ||
            (isKeplrConnected && connectedKeplrWalletAddress) ||
            isAlgoConnected) && (
            <>
              <SwapMobilePage {...SwapMobilePageProps} />
              <div className="desktop-view">
                <FCard variant="multiswap-primary">
                  <FGrid className="ms-card-swap-header">
                    <FGridItem
                      size={[4, 4, 4]}
                      className="ms-card-heading f-p-2"
                    >
                      MultiSwap
                    </FGridItem>
                    <FGridItem
                      size={[8, 8, 8]}
                      className="ms-card-heading-info f-p-2"
                    >
                      <div className="ms-card-heading-info-dropdown-wrapper">
                        <ReactTooltip place="top" type="dark" effect="float" />
                        <a className="tooltip text">
                          <div
                            className="ms-card-heading-info-dropdown cursor-pointer"
                            onClick={() => {
                              // addClassToBodyTag(true);
                              // setShowFeeTokenSelectorDialog(true);
                            }}
                          >
                            <span className="ms-card-mt-10 ms-swap-header-token-name">
                              Fee Token:
                            </span>
                            <span className="ms-card-mt-10"> Coming Soon</span>

                            <MdKeyboardArrowDown
                              className="ms-card-mt-10"
                              size={18}
                            />
                          </div>
                        </a>
                      </div>
                      <div
                        className={`ms-card-heading-info-address-wrapper ${
                          sendToToggle && "expanded"
                        }`}
                      >
                        <div
                          className={`ms-card-heading-info-address ${
                            destinationAddress && isDestinationAddressValid
                              ? "valid-address"
                              : destinationAddress && !isDestinationAddressValid
                              ? "invalid-address"
                              : ""
                          }`}
                        >
                          <span
                            className="d-flex ai-center"
                            onClick={() => setSendToToggle(!sendToToggle)}
                          >
                            <img
                              width={"20px"}
                              src={addItemIcon}
                              alt="add item icon"
                              className="cursor-pointer f-pr--3"
                            />
                            <label className="cursor-pointer">Send To</label>
                          </span>
                          {sendToToggle && (
                            <input
                              placeholder="Destination Address"
                              value={destinationAddress}
                              ref={sendToRef}
                              onChange={(e: any) => {
                                localStorage.setItem(
                                  "persist:focusType",
                                  "sendTo"
                                );
                                queryParams.set("sendTo", e.target.value);
                                history.push({
                                  pathname: "/swap",
                                  search: queryParams.toString(),
                                });
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div
                        className="ms-card-heading-info-icon cursor-pointer"
                        onClick={() => {
                          addClassToBodyTag(true);
                          setShowSwapToggleDialog(true);
                        }}
                      >
                        <ReactTooltip place="top" type="dark" effect="float" />
                        <a
                          className="tooltip text"
                          data-tip={`Slippage is currently set to ${slippage}% on source and destination networks`}
                        >
                          <img src={toggleIcon} alt="toggle icon" />
                        </a>
                      </div>
                    </FGridItem>
                  </FGrid>
                  <FGrid className="m-0">
                    <FGridItem size={[12, 12, 12]}>
                      <SwapPageTokenNetworkSelector
                        selectorFor={"From"}
                        selectorInfo={fromInfo}
                        isApproving={isApproving}
                        networkParamsShift={networkParamsShift}
                        setNetworkParamsShift={setNetworkParamsShift}
                        setShowTokenSelectorDialog={setShowTokenSelectorDialog}
                        setTokenSelectorDialogFor={setTokenSelectorDialogFor}
                      />
                      <FGridItem
                        size={[2, 2, 2]}
                        className={`ms-card-select-swap text-end ${
                          (Number(amount) > 0 &&
                            maxBalance &&
                            new Big(amount).gt(new Big(maxBalance))) ||
                          showAmountWarning
                            ? "enter-amount"
                            : ""
                        } `}
                      >
                        <div className="ms-card-select-swap-amount">
                          <p>
                            <input
                              onClick={(e: any) => e.target.select()}
                              value={amount ? amount : ""}
                              placeholder="0.0"
                              ref={inputRef}
                              disabled={!fromInfo?.token}
                              onChange={(e: any) => {
                                onSourceAmountChange(e);
                              }}
                            />
                          </p>
                          {/* <button className="max-btn"> */}
                          <div className="custom-font-size-11 w-100">
                            <span
                              className="ms-card-select-swap-max cursor_pointer"
                              onClick={(e: any) => sourceMaxButton()}
                              ref={maxRef}
                            >
                              {" "}
                              MAX
                            </span>{" "}
                            {maxBalance
                              ? Number(maxBalance).toFixed(3)
                              : ""}{" "}
                            {fromInfo?.token?.symbol
                              ? fromInfo?.token?.symbol
                              : ""}
                          </div>
                          {/* </button> */}
                        </div>
                      </FGridItem>
                      <FGridItem
                        size={[2, 2, 2]}
                        className="ms-card-select-swap swap-logo"
                      >
                        <div
                          className="cursor-pointer"
                          onClick={() => switchFromAndToInfo()}
                        >
                          <img src={swapSwitchIcon} alt="swap icon" />
                        </div>
                      </FGridItem>
                      <FGridItem
                        size={[2, 2, 2]}
                        className={`ms-card-select-swap text-end`}
                      >
                        <div className="ms-card-select-swap-amount">
                          <p className="font-size-30">
                            {destinationAmount ? (
                              <input
                                className="text-align-left"
                                value={
                                  destinationAmount && Number(amount) > 0
                                    ? destinationAmount
                                    : "0.0"
                                }
                              />
                            ) : isTokenQuoteLoading ? (
                              <>
                                <span color="#C4C4C5">Fetching Quote</span>
                                <img
                                  className="destination-amount-loader"
                                  src={Loader}
                                  alt={"loader icon"}
                                  height={15}
                                  width={15}
                                />
                              </>
                            ) : null}
                          </p>
                        </div>
                      </FGridItem>
                      <SwapPageTokenNetworkSelector
                        selectorFor={"To"}
                        selectorInfo={toInfo}
                        isApproving={isApproving}
                        setTokenSelectorDialogFor={setTokenSelectorDialogFor}
                        networkParamsShift={networkParamsShift}
                        setShowTokenSelectorDialog={setShowTokenSelectorDialog}
                        setNetworkParamsShift={setNetworkParamsShift}
                      />
                    </FGridItem>
                  </FGrid>
                  <p className="ms-card-swap-estimated-time">
                    {fromInfo?.token && toInfo?.token ? estimatedSwapTime : ""}{" "}
                    {isSwappingScreenBlocked && "Please Wait..."}
                  </p>
                  <FGrid>
                    <FGridItem
                      size={[12]}
                      className={`ms-card-token-button ${
                        !fromInfo?.token || !toInfo?.token ? "f-pt--8" : ""
                      } `}
                    >
                      <SwapPageActionButtons {...SwapActionProps} />
                    </FGridItem>
                  </FGrid>
                </FCard>
              </div>
              {fromInfo?.token && toInfo?.token ? (
                <>
                  <div className="desktop-view">
                    <FCard variant="multiswap-primary-footer">
                      <div className="ms-card-swap-footer">
                        <div className="ms-card-swap-footer-logo">
                          <img src={fiberEngineIcon} alt="fiber Engine Icon" />
                        </div>
                        <SwapProgressBar
                          networkProgressBarDisable={networkProgressBarDisable}
                          swapProgressBar={swapProgressBarStatus}
                          progressBar={progressBar}
                        />
                        {!networkProgressBarDisable && (
                          <CategorizationProgressBar
                            progressBar={progressBar}
                          />
                        )}
                      </div>
                    </FCard>
                  </div>
                  <FCard variant="multiswap-secondary-footer">
                    <div className="ms-card-swap-footer-info-wrapper">
                      <FGrid className="f-ml-1 ms-card-swap-footer-info">
                        <FGridItem size={[3, 3, 3]} className="f-p-0">
                          <span className="ms-card-swap-footer-info-heading">
                            Platform Fee:
                          </span>
                          <ReactTooltip
                            place="top"
                            type="dark"
                            effect="float"
                          />
                          <a className="  tooltip text" data-tip="Coming soon">
                            <label className="f-ml-1"> TBD</label>
                          </a>
                        </FGridItem>
                        <FGridItem size={[3, 3, 3]} className="f-p-0">
                          <span className="ms-card-swap-footer-info-heading">
                            Gas Fee:
                          </span>
                          <ReactTooltip
                            place="top"
                            type="dark"
                            effect="float"
                          />
                          <a className="  tooltip text" data-tip="Coming soon">
                            <label className="f-ml-1">TBD</label>
                          </a>
                          {/* <label>{gasEstimatedPrice}</label> */}
                        </FGridItem>
                        <FGridItem size={[3, 3, 3]} className="f-p-0">
                          <span className="ms-card-swap-footer-info-heading">
                            Minimum Recieved:
                          </span>
                          <label className="f-ml-1">
                            {Number(destinationAmount).toFixed(5)}
                          </label>
                        </FGridItem>
                        <FGridItem size={[3, 3, 3]} className="d-flex">
                          <span className="ms-card-swap-footer-info-heading">
                            Price Impact:{" "}
                          </span>
                          <label className="f-ml-1">TBD</label>
                          <FTooltip
                            className={"p-0 f-mt-0"}
                            effect={"solid"}
                            place={"top"}
                            id="TooltipTop"
                            textColor={"white"}
                            backgroundColor={"black"}
                            text={
                              <RiErrorWarningLine className="warning-icon" />
                            }
                          >
                            <div className="ms-tooltip">
                              <span>{COMING_SOON}</span>
                            </div>
                          </FTooltip>
                        </FGridItem>
                      </FGrid>
                    </div>
                  </FCard>
                </>
              ) : null}
            </>
          )}
        </>
      )}
      {showTokenSelectorDialog ? (
        <MsTokenListDialog
          tokensList={
            tokenSelectorDialogFor === "FROM_TOKEN" ||
            tokenSelectorDialogFor === "FROM_NETWORK"
              ? fromNetworkTokenList
              : toNetworkTokenList
          }
          networks={networksPayload}
          show={showTokenSelectorDialog}
          selectorDialogFor={tokenSelectorDialogFor}
          onHide={() => {
            addClassToBodyTag(false);
            setShowTokenSelectorDialog(false);
            setNetworkParamsShift(true);
          }}
          setQuoteLoading={setQuoteLoading}
        />
      ) : null}
      <MsSelectFeeTokenDlg
        networks={networksPayload}
        show={showFeeTokenSelectorDialog}
        onHide={() => {
          addClassToBodyTag(false);
          setShowFeeTokenSelectorDialog(false);
        }}
      />
      <MsDestinationDialog
        show={showDestinationAddressDialog}
        onHide={() => {
          addClassToBodyTag(false);
          setShowDestinationAddressDialog(false);
        }}
      />
      <MsSlippageToleranceDialog
        show={showSwapToggleDialog}
        onHide={() => {
          addClassToBodyTag(false);
          setShowSwapToggleDialog(false);
        }}
      />
    </FContainer>
  );
};
export default SwapPage;
